<template>
    <div>
        <div class="row">
            <div class="col-md-8">
                <h3>Additional Permission</h3>
            </div>
            <div class="col-md-4">
                <p-button 
                    class="btn btn-success pull-right"
                    @click="openAssignPermissionModal"
                    v-if="hasAssignAdditionalPermission">
                    <i class="fas fa-user-shield"></i> Assign Additional Permission
                </p-button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 card">
                <div class="card-body row"> 
                    <div class="col-2">
                        <el-select
                        class="select-default"
                        v-model="pagination.perPage"
                        placeholder="Per page"
                        size="mini">
                        <el-option
                            class="select-default"
                            v-for="item in pagination.perPageOptions"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                        </el-select>
                    </div>
                    <div class="col-sm-12 mt-2">
                        <el-table class="table-striped"
                                :data="tableData"
                                border
                                style="width: 100%">
                        <el-table-column v-for="column in tableColumns"
                                        align="center"
                                        :key="column.label"
                                        :min-width="column.minWidth"
                                        :prop="column.prop"
                                        :label="column.label">
                        </el-table-column>
                        <!-- <el-table-column
                            :min-width="50"
                            fixed="right"
                            align="center"
                            class-name="td-actions"
                            label="Actions">
                            <template slot-scope="props">
                            <p-button type="danger" size="sm" icon @click="handleDelete(props.$index, props.row)">
                                <i class="fa fa-trash-alt"></i>
                            </p-button>
                            </template>
                        </el-table-column> -->
                        </el-table>
                    </div>
                    <div class="col-sm-6 pagination-info">
                        <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
                    </div>
                    <div class="col-sm-6">
                        <p-pagination class="pull-right"
                                    v-model="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :total="pagination.total"
                                    @input="inputChanged($event)">
                        </p-pagination>
                    </div>
                </div>
            </div>
        </div>
    <!-- assign additional permission modal -->
    <modal :show.sync="assignPermissionModal"
        footer-classes="justify-content-center"
        type="notice">
    <h5 slot="header" class="text-primary modal-title">Assign Permission</h5>
    <template>
        <form>
        <div class="form-group">
            <fg-input
                :error="getError('permissions')">
              <label for="inputStatus">Permissions</label>
              <div class="form-group">
                <input
                    type="checkbox" id="SelectAll" v-model="selectAllPermissionsBool" 
                    @click="selectAllPermissions"/>
                <label class="form-check-label" for="SelectAll"><b> Select All </b></label>
              </div>

              <div class="form-group" v-for="permission in permissions" v-bind:key="permission.id">
                <input
                  type="checkbox"
                  name="permissions"
                  v-model="permissionIdList"
                  :id="permission.id"
                  :value="permission.id"
                  v-validate="'required|min:1'"  />
                <label class="form-check-label" :for="permission.id"> {{ permission.name }}</label>
              </div>
            </fg-input>
        </div>
        </form>
    </template>
    <template slot="footer">
        <p-button type="danger" @click.native="assignPermissionModal = false">Close</p-button>
        <p-button type="success" @click.native="assignPermissionValidation" >Assign Permission</p-button>
        
    </template>
    </modal>
    </div>
</template>

<script>
    import HTTP from 'src/util/http-common.js';
    import Modal from 'src/components/UIComponents/Modal.vue';
    import swal from 'sweetalert2'

    export default {
        name: 'additional-permission-list',
        components: {
            Modal
        },
        data() {
            return {
                pagination: {
                    perPage: 10,
                    currentPage: 1,
                    perPageOptions: [2, 5, 10, 25, 50],
                    total: 0
                },
                tableData: [],
                tableColumns: [
                    {
                        prop: 'name',
                        label: 'Permission',
                        minWidth: 50
                    },
                    {
                        prop: 'description',
                        label: 'Description',
                        minWidth: 50
                    }
                ],
                permissions: [],
                assignPermissionModal: false,
                permissionIdList: [],
                selectAllPermissionsBool: false,
                generalPermissions: this.$store.getters['auth/generalPermissions']
            }
        },
        computed: {
            to () {
                let highBound = this.from + this.pagination.perPage
                if (this.total < highBound) {
                    highBound = this.total
                }
                return highBound
            },
            from () {
                return this.pagination.perPage * (this.pagination.currentPage - 1)
            },
            total () {
                return this.pagination.total
            },
            hasAssignAdditionalPermission() {
                if (this.generalPermissions.includes('additional_permission.post')) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        created() {
            this.fetchAdditionalPermissionList()
            console.log(this.permissionIdList)
        },
        watch: {
            "assignPermissionModal": function(newVal, oldVal) {
                console.log(newVal, oldVal)
                if (newVal == false) {
                    this.$validator.pause();
                    this.permissions = [];
                    this.$validator.errors.clear();
                    this.selectAllPermissionsBool = false;
                }
            }
        },
        methods: {
            handleDelete() {

            },
            handleEdit() {

            },
            async fetchPermissions() {
                let params = {
                permission_level: 'global'
                }
            
                const response = await HTTP.get('api/v1/permission/list', {
                    params: params
                });
                const data = await response.data;
                return data;
            },
            setPermissions() {
                let loader = this.$loading.show();
                this.fetchPermissions()
                .then(data => {
                    const results = data.results
                    for (let row of data.results) {
                        this.permissions.push({
                            'id': row.id,
                            'name': row.description
                        })
                    }                    
                    loader.hide();
                }).catch(err => {
                    this.$notify({
                        group: 'general',
                        title: 'Error fetching Permission list',
                        text: err,
                        type: 'error'
                    });
                    loader.hide();
                })
            },
            openAssignPermissionModal() {
                this.assignPermissionModal = true;
                this.setPermissions()

            },
            selectAllPermissions() {
                if (this.selectAllPermissionsBool == false) {
                    this.selectAllPermissionsBool = true;
                    for (let row of this.permissions) {
                        this.permissionIdList.push(row.id)
                    }
                    console.log(this.permissionIdList);
                } else {
                    this.selectAllPermissionsBool = false;
                    this.permissionIdList = []
                }
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            async assignPermissionValidation() {
              this.$validator.resume();
              const isValid = await this.$validator.validateAll();
              console.log("isValid", isValid)
              if (isValid) {
                this.assignPermissionAPI();
              }
            },
            assignPermissionAPI() {
                let loader = this.$loading.show();
                var params = {
                    user_id: this.$route.params.userId,
                    permission_id_list: this.permissionIdList
                }
                HTTP.post('api/v1/user/additional-permission/list', params)
                    .then(response => { 
                        this.assignPermissionModal = false;
                        swal({
                            title: "Successfully assigned additional permissions",
                            text: '',
                            buttonsStyling: false,
                            confirmButtonClass: 'btn btn-success btn-fill',
                            type: 'success'
                        })
                        this.fetchAdditionalPermissionList();
                        loader.hide();
                        this.$store.dispatch('auth/retrieveUserGeneralPermissions')
                    }).catch(err => {
                        this.assignPermissionModal = false;
                        if (err.response) {
                        // Request made and server responded
                            const error = err.response.data.error
                            const status_code = err.response.status
                            if ('errors' in err.response.data) {
                                    swal({
                                    title: "Bad Request",
                                    text: err.response.data.message,
                                    buttonsStyling: false,
                                    confirmButtonClass: 'btn btn-danger btn-fill',
                                    type: 'error'
                                })
                                return;
                            }
                            if (status_code == 500) {
                                swal({
                                    title: "Server Error",
                                    text: "Internal Server Error. Please try again later..",
                                    buttonsStyling: false,
                                    confirmButtonClass: 'btn btn-danger btn-fill',
                                    type: 'error'
                                })
                            } else {
                                swal({
                                    title: "Bad Request",
                                    text: error,
                                    buttonsStyling: false,
                                    confirmButtonClass: 'btn btn-danger btn-fill',
                                    type: 'error'
                                })   
                            }
                        } else if (err.request) {
                        // The request was made but no response was received
                            swal({
                                title: 'Server Error',
                                text: err.request,
                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger btn-fill',
                                type: 'error'
                            })
                        } else {
                            console.log(err)
                        // Something happened in setting up the request that triggered an Error
                            swal({
                                title: 'Error',
                                text: err.message,
                                buttonsStyling: false,
                                confirmButtonClass: 'btn btn-danger btn-fill',
                                type: 'error'
                            })
                        }
                        loader.hide();
                    })
            },
            fetchAdditionalPermissionList() {
                this.permissionIdList = [];
                var params = {
                    user_id: this.$route.params.userId,
                    page: this.pagination.currentPage,
                    page_size: this.pagination.perPage
                }
                HTTP.get('api/v1/user/additional-permission/list', {params: params})
                .then(response => {     
                    var data = response.data
                    this.tableData = data.results;
                    this.pagination.total = data.total
                    for (let row of data.results) {
                        this.permissionIdList.push(row.id)
                    }

                }).catch(err => {
                    if (err.response) {
                    // Request made and server responded
                        const error = err.response.data.error
                        const status_code = err.response.status
                        if ('errors' in err.response.data) {
                            this.$notify({
                                group: 'general',
                                title: 'Error fetching Permission list',
                                text: err.response.data.message,
                                type: 'error'
                            });
                            return;
                        }
                        if (status_code == 500) {
                            this.$notify({
                                group: 'general',
                                title: 'Error fetching Permission list',
                                text: "Internal Server Error. Please try again later..",
                                type: 'error'
                            });
                        } else {
                            this.$notify({
                                group: 'general',
                                title: 'Error fetching Permission list',
                                text: error,
                                type: 'error'
                            });  
                        }
                    } else if (err.request) {
                        this.$notify({
                            group: 'general',
                            title: 'Error fetching Permission list',
                            text: err.request,
                            type: 'error'
                        });  
                    // The request was made but no response was received
                    } else {
                        this.$notify({
                            group: 'general',
                            title: 'Error fetching Permission list',
                            text: err.message,
                            type: 'error'
                        });
                    // Something happened in setting up the request that triggered an Error
                    }
                })
            },
            inputChanged(pageNum) {
                console.log('page changed', pageNum)
                this.fetchAdditionalPermissionList();
            },
        },
        beforeDestroy() {
            console.log("hey before destroy")
            this.permissions = [];
        }
    }
</script>